<template>
  <div class="form-group">
    <div class="form-check">
      <input class="form-check-input" type="checkbox" id="inSaleCheck" v-model="inSale">
      <label class="form-check-label" for="inSaleCheck">
        im Verkauf
      </label>
    </div>
    <div class="form-check">
      <input class="form-check-input" type="checkbox" id="tripCheck" v-model="tripOnly">
      <label class="form-check-label" for="tripCheck">
        nur Fahrten
      </label>
    </div>
    <div v-if="false">
      <div v-for="category in ['RES', 'VOU', 'WEL', 'REN', 'PER']"
      :key="category">
      <input class="form-check-input"
             type="checkbox"
             :id="'cat_' + category"
             v-model="tripOnly">
        <label :for="'#cat_' + category">
          {{category}}
        </label>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  props: {
    articles: Array
  },
  data() {
    return {
      tripOnly: true,
      reservationOnly: true,
      inSale: true,
      selectedCategories: ['RES', 'VOU', 'WEL', 'REN']
    }
  },
  computed: {
    filteredArticles() {
      return [...this.articles]
          .filter(a => this.selectedCategories.filter(c => c === a.product.category).length > 0)
          .filter(a => !this.tripOnly || a.product.trip)
          .filter(a => !this.inSale || a.inSale)
    }
  },
  watch: {
    filteredArticles: {
      handler(newVal) {
        this.$emit('filter', newVal)
      },
      immediate: true
    }
  }
}
</script>
